import { render, staticRenderFns } from "./BIParameterRulesTable.vue?vue&type=template&id=100c2d23&"
import script from "./BIParameterRulesTable.vue?vue&type=script&lang=js&"
export * from "./BIParameterRulesTable.vue?vue&type=script&lang=js&"
import style0 from "./BIParameterRulesTable.vue?vue&type=style&index=0&id=100c2d23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports